import { styled, Tooltip } from '@mui/material';
import { tooltipClasses } from '@mui/material/Tooltip';

const HtmlTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
    ({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: '#f5f5f9',
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 'fit-content',
            fontSize: theme.typography.pxToRem(16),
            border: '1px solid #dadde9',
            whiteSpace: 'pre',
        },
    }),
);

export default HtmlTooltip;
